/**
 * Get locale user language
 */
export function getLang() {
  return (
    (navigator.languages && navigator.languages[0]) ||
    navigator.language ||
    navigator.userLanguage
  );
}

/**
 * Translate a nomenclature item
 * 
 * @param {{ translations: {[key: string]: {[key: string] : string}} }} item The item to translate
 * @param {string} property The name of the property to translate
 * @param {string} lang  The language to translate to
 * @param {string} fallback The fallback value to use if no translation is found
 */
export function translateNomenclature(item, property, lang, fallback = "") {
  return item.translations?.[lang]?.[property] ?? item.translations?.["en"]?.[property] ?? item[property] ?? fallback;
}
